import {
  AuthenticationDetails,
  CognitoUser,
  CognitoUserPool,
  CognitoUserSession,
} from "amazon-cognito-identity-js";
import { config } from "./config";

const pool = new CognitoUserPool({
  UserPoolId: config.cognito.userPoolId,
  ClientId: config.cognito.clientId,
});

export type AuthUser = {
  email: string;
  name: string;
};

function sessionToUser(session: CognitoUserSession): AuthUser {
  const payload = session.getIdToken().decodePayload();
  const email = String(payload.email ?? payload["cognito:username"] ?? "");
  return {
    email,
    name: String(payload.name ?? email.split("@")[0] ?? "Demo user"),
  };
}

export function getCurrentSession(): Promise<CognitoUserSession | null> {
  const user = pool.getCurrentUser();
  if (!user) return Promise.resolve(null);
  return new Promise((resolve) => {
    user.getSession((err: Error | null, session: CognitoUserSession | null) => {
      if (err || !session?.isValid()) resolve(null);
      else resolve(session);
    });
  });
}

export async function getAccessToken(): Promise<string | null> {
  const session = await getCurrentSession();
  return session?.getAccessToken().getJwtToken() ?? null;
}

export async function getCurrentUser(): Promise<AuthUser | null> {
  const session = await getCurrentSession();
  return session ? sessionToUser(session) : null;
}

export function signIn(email: string, password: string): Promise<AuthUser> {
  const user = new CognitoUser({ Username: email.trim().toLowerCase(), Pool: pool });
  const auth = new AuthenticationDetails({
    Username: email.trim().toLowerCase(),
    Password: password,
  });

  return new Promise((resolve, reject) => {
    user.authenticateUser(auth, {
      onSuccess: (session) => resolve(sessionToUser(session)),
      onFailure: (err) => reject(err),
      newPasswordRequired: () => {
        reject(new Error("Password change required. Contact contact@govsuite.us."));
      },
    });
  });
}

export function signOut(): void {
  pool.getCurrentUser()?.signOut();
}
